import styled from 'styled-components';

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const Message = styled.div`
  margin-top: 10%;
  fontfamily: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
  font-size: large;
  font-weight: bold;
`;
